import { useEffect, useState } from "react";
import { API, graphqlOperation } from "aws-amplify";
import { useDispatch } from "react-redux";
 // adjust path as needed
import { useSelector } from "react-redux";
import { createCompanyPreference, createUserPreference } from "../../../graphql";
import { fetchUserPreference } from "../../../redux/reducers/UserPreference";
import { companyPreferenceApi, useCreateCompanyPreferenceMutation, useListCompanyPreferenceQuery } from "../../../redux/apis/companyPreference.api";

export function UseShareModal({
  attributeTypeCd
}) {
    const [createCompanyPreference, { isLoading: creating }] = useCreateCompanyPreferenceMutation();
     const userPreferenceAndFY = useSelector(
        (state) => state?.userPrefrenceandReducer
      );
        const { data: companyPreference } = useListCompanyPreferenceQuery();
        const salesPref = companyPreference?.find((pref) => pref.attributetypecd === 'SalesPrint');
        const isSalesShow = salesPref?.attributevalue || 0;
      
  const [localValue, setLocalValue] = useState(isSalesShow);
  const dispatch = useDispatch();

  useEffect(() => {
    setLocalValue(isSalesShow);
  }, [isSalesShow]);

  const updatePreference = async (checked) => {
    setLocalValue(checked); 
    try {
      const value = checked ? 1 : 0;
      const userPreferenceData = {
        additionalvalue: "",
        attributetypecd: attributeTypeCd,
        attributevalue: value,
      };

          await createCompanyPreference({
            createCompanyPreferenceInput: userPreferenceData,
          });

   dispatch(companyPreferenceApi.util.invalidateTags(['listCompanyPreference']));
    } catch (error) {
      console.error("Error updating preference:", error);
    }
  };

  return [localValue, updatePreference];
}
